import type { InsightDataItem, TelehealthReportInsights } from '@/api/print/types';

type ReportInsightsPageProps = {
  insights: TelehealthReportInsights;
};

function DataSection({ title, data }: { title: string; data: InsightDataItem[] }) {
  if (!data || data.length === 0) return null;

  return (
    <div className="mb-1">
      <p className="text-[10px] font-bold text-gray-800 mb-0.5">{title}:</p>
      {data.map((item) => (
        <div key={item.name} className="flex justify-between text-[10px] text-gray-600 leading-4">
          <span>{item.name}:</span>
          <span>{item.value}</span>
        </div>
      ))}
    </div>
  );
}

export function ReportInsightsPage({ insights }: ReportInsightsPageProps) {
  return (
    <div className="flex-1 pt-2">
      <h2 className="text-lg font-bold text-[#152644] mb-2">Insights Analysis</h2>

      <div className="grid grid-cols-2 gap-2">
        {insights.images.map((image) => (
          <div
            key={image.position_key}
            className="border border-gray-300 rounded p-2 print-no-break"
          >
            <h3 className="text-xs font-bold text-gray-900 mb-1">{image.position_name}</h3>
            <hr className="border-gray-300 mb-1" />

            <DataSection title="Vessel" data={image.category_data.vessel_data} />
            <DataSection title="Optic Disc" data={image.category_data.optic_disc_data} />
            <DataSection title="Lesion" data={image.category_data.lesion_data} />
          </div>
        ))}
      </div>
    </div>
  );
}
